import { useFormContext } from "react-hook-form";
import { Checkbox, FormControl, FormControlLabel } from "@mui/material";
import daLiJePoljeValidno from "../../../../utils/daLiJePoljeValidno";
import { PorukaGreskePolja } from "../../../index";
import { useEffect } from "react";
import { VRSTA_OPERATERA } from "../../../../enums";
const Index = (props: any) => {
  const { register, setValue, getValues, watch } = useFormContext();
  const watchField = watch("izjavaOOdgovornosti");
  const checked = getValues("izjavaOOdgovornosti");

  const vrstaOperatera = getValues("operaterPlatforme.vrstaOperatera.id");

  useEffect(() => {
    setValue(
      "izjavaOOdgovornosti",
      vrstaOperatera === VRSTA_OPERATERA.IZVAN_EU
    );
  }, [vrstaOperatera]);

  if (vrstaOperatera === VRSTA_OPERATERA.IZVAN_EU) return null;

  return (
    <FormControl fullWidth error={!daLiJePoljeValidno("izjavaOOdgovornosti")}>
      <FormControlLabel
        control={
          <Checkbox
            {...register("izjavaOOdgovornosti")}
            checked={checked}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setValue("izjavaOOdgovornosti", e.target.checked)
            }
          />
        }
        label="*Pod materijalnom i kaznenom odgovornošću izjavljujem da nadležna tijela mogu provjeriti moje podatke u svrhu usklađivanja gore navedenih podataka te svrstavanje u isključene operatere. (I declare under material and criminal responsibility that competent authorities may verify my data for the purpose of reconciliation of the above stated data and classification as Excluded Platform Operator.)"
      />
      <PorukaGreskePolja nazivPolja={"izjavaOOdgovornosti"} />
    </FormControl>
  );
};

export default Index;
